import {deepQueryTree} from '@/utils/common'
import bbwSiteApi from '@/api/bbw/bbwSite'
import bbwPurchaseApi from '@/api/bbw/bbwPurchase'

const state = {
    // 是否已经获取过对应的 可见栏目
    role: new Map(),
    // 所有的可见栏目
    menus: [],
    // 所有的menu, 不区分 是否显示, list
    allMenusList: [],
    // 所有的menu 树
    allMenusTree: [],
    // 站点信息
    siteInfo: {},
    // 当前选中的菜单
    activeMenu: {},
    // 当前选中的节点树
    activeMenuTree: [],
    // 当前选中的节点子节点(如果当前节点已经是叶子节点,则会将同一父级下的所有子节点放置在当前节点中)
    activeMenuChildren: [],
    enterprises: [],
    currentProject: {},
    currentBids: [],
    currentNotice: {},
    noticeHtml: '',
    // 特殊栏目单独分离，再获取时直接分离
    //新闻资讯
    channel_xwzx: {},
    //关于我们
    channel_gywm: {},
    //资料下载
    channel_zlxz: {},
    //常见问题
    channel_cjwt: {},
    //合作机构
    channel_hzjg: {},
    //友情链接
    channel_yqlj: {},
    //业务指南
    channel_ywzn: {},
    //联系我们
    channel_lxwm: {},
    //操作指引
    channel_czzy: {},
    //数据统计
    channel_sjtj: {},
}
const mutations = {
    SET_ROLE: (state, {action, role}) => {
        state.role[action](role, role)
    },
    SET_MENUS: (state, menus) => {
        state.menus = menus || []
    },
    SET_ALL_MENUS_LIST: (state, menus) => {
        state.allMenusList = menus || []
    },
    SET_ALL_MENUS_TREE: (state, menus) => {
        state.allMenusTree = menus || []
    },
    SET_SITE_INFO: (state, info) => {
        state.siteInfo = info || {}
    },
    SET_ACTIVE_MENU: (state, activeMenu) => {
        console.log("SET_ACTIVE_MENU", activeMenu)
        state.activeMenu = activeMenu || {}
    },
    SET_ACTIVE_MENU_TREE: (state, activeMenuTree) => {
        console.log("SET_ACTIVE_MENU_TREE", activeMenuTree)
        state.activeMenuTree = activeMenuTree || []
    },
    SET_ACTIVE_MENU_CHILD: (state, activeMenuChildren) => {
        state.activeMenuChildren = activeMenuChildren || []
    },
    SET_ENTERPRISES: (state, enterprises) => {
        console.log('SET_ENTERPRISES', enterprises)
        state.enterprises = enterprises || []
    },
    SET_CURRENTPROJECT: (state, currentProject) => {
        console.log('SET_CURRENTPROJECT', currentProject)
        state.currentProject = currentProject || []
    },
    SET_CURRENT_BIDS: (state, currentBids) => {
        console.log('SET_CURRENT_BIDS', currentBids)
        state.currentBids = currentBids || []
    },
    SET_CURRENT_NOTICE: (state, currentNotice) => {
        console.log('SET_CURRENT_NOTICE', currentNotice)
        state.currentNotice = currentNotice || {}
    },
    SET_NOTICE_HTML: (state, noticeHtml) => {
        state.noticeHtml = noticeHtml || '获取公告正文失败'
    },

    //特殊栏目单独记录
    SET_CHANNEL_XWZX: (state, channelData) => {
        state.channel_xwzx = channelData || {}
    },
    SET_CHANNEL_GYWM: (state, channelData) => {
        state.channel_gywm = channelData || {}
    },
    SET_CHANNEL_ZLXZ: (state, channelData) => {
        state.channel_zlxz = channelData || {}
    },
    SET_CHANNEL_CJWT: (state, channelData) => {
        state.channel_cjwt = channelData || {}
    },
    SET_CHANNEL_HZJG: (state, channelData) => {
        state.channel_hzjg = channelData || {}
    },
    SET_CHANNEL_YQLJ: (state, channelData) => {
        state.channel_yqlj = channelData || {}
    },
    SET_CHANNEL_YWZN: (state, channelData) => {
        state.channel_ywzn = channelData || {}
    },
    SET_CHANNEL_LXWM: (state, channelData) => {
        state.channel_lxwm = channelData || {}
    },
    SET_CHANNEL_CZZY: (state, channelData) => {
        state.channel_czzy = channelData || {}
    },
    SET_CHANNEL_SJTJ: (state, channelData) => {
        state.channel_sjtj = channelData || {}
    },
}
const actions = {
    // 获取栏目树
    getMenuTree({commit}) {
        return new Promise((resolve, reject) => {
            bbwSiteApi
                .channelTree()
                .then((res) => {
                    //设置菜单数据，不区分权限
                    commit('SET_MENUS', res.data)
                    //1.构造菜单树
                    commit('SET_ALL_MENUS_TREE', res.data)
                    //2.拆解数组为list,只找到第二层
                    let list = []
                    for (const item of res.data) {
                        list.push(item)
                        for (const children of item.children) {
                            list.push(children)
                        }
                    }
                    commit('SET_ALL_MENUS_LIST', list)
                    //分离特殊栏目
                    commit(
                        'SET_CHANNEL_XWZX',
                        list.filter((menu) => menu.channelPath === 'xwzx')
                    )
                    commit(
                        'SET_CHANNEL_GYWM',
                        list.filter((menu) => menu.channelPath === 'gywm')
                    )
                    commit(
                        'SET_CHANNEL_ZLXZ',
                        list.filter((menu) => menu.channelPath === 'zlxz')
                    )
                    commit(
                        'SET_CHANNEL_CJWT',
                        list.filter((menu) => menu.channelPath === 'cjwt')
                    )
                    commit(
                        'SET_CHANNEL_HZJG',
                        list.filter((menu) => menu.channelPath === 'hzjg')
                    )
                    commit(
                        'SET_CHANNEL_YQLJ',
                        list.filter((menu) => menu.channelPath === 'yqlj')
                    )
                    commit(
                        'SET_CHANNEL_YWZN',
                        list.filter((menu) => menu.channelPath === 'ywzn')
                    )
                    commit(
                        'SET_CHANNEL_LXWM',
                        list.filter((menu) => menu.channelPath === 'lxwm')
                    )
                    commit(
                        'SET_CHANNEL_CZZY',
                        list.filter((menu) => menu.channelPath === 'czzy')
                    )
                    commit(
                        'SET_CHANNEL_SJTJ',
                        list.filter((menu) => menu.channelPath === 'sjtj')
                    )
                    resolve()
                })
                .catch((err) => {
                    console.error('栏目树获取失败:', err)
                    commit('SET_MENUS', [])
                    reject()
                })
        })
    },
    // 获取站点信息
    getSiteInfo({commit}) {
        return new Promise((resolve, reject) => {
            bbwSiteApi
                .channelDetailByPath('zdxx')
                .then((res) => {
                    // 取值于ext字段
                    let siteInfo = JSON.parse(res.data.ext)
                    commit('SET_SITE_INFO', siteInfo)
                    //设置站点标题
                    document.title = siteInfo.siteTitle
                    resolve()
                })
                .catch((err) => {
                    console.error('站点信息获取失败:', err)
                    commit('SET_SITE_INFO', [])
                    reject()
                })
        })
    },
    //获取企业信息
    async getEnterprises({commit, state}) {
        //1.检查是否有配置cods，并尝试获取
        console.log("get_enclosureUpload2TtN", state.siteInfo.enclosureUpload2TtN)
        let siteInfo = state.siteInfo
        siteInfo.jsonConfig = {}
        if (state.siteInfo.enclosureUpload2TtN?.length > 0) {
            try {
                let jsonData = await bbwSiteApi.getSiteJson(state.siteInfo.enclosureUpload2TtN[0].url)
                if (jsonData.cods !== undefined) {
                    siteInfo.jsonConfig = jsonData
                }
            } catch (error) {
                console.error("站点配置错误:", error)
            }
            commit('SET_SITE_INFO', siteInfo)
        }
        //2.存储cods对象在siteinfo里
        let cods = ""
        // eslint-disable-next-line no-prototype-builtins
        if (state.siteInfo.jsonConfig?.hasOwnProperty('cods')) {
            cods = state.siteInfo.jsonConfig.cods.join(',')
        }
        return new Promise((resolve, reject) => {
            bbwPurchaseApi
                .get_enterprises(state.siteInfo.ownershipRegion, cods)
                .then((res) => {
                    console.log('SET_ENTERPRISES', res)
                    commit('SET_ENTERPRISES', res.data)
                    resolve()
                })
                .catch((err) => {
                    console.error('企业信息获取失败:', err)
                    commit('SET_ENTERPRISES', [])
                    reject()
                })
        })
    },
    // 获取当前激活的栏目
    getActiveMenu({commit, state}, route) {
        const {
            params: {column},
            path,
        } = route
        const menuById = state.allMenusList.filter(
            (item) => item.id === Number(column)
        )[0]
        const menuByPath = state.allMenusList.filter(
            (item) => item.path === path
        )[0]
        const menu = Object.assign({}, menuById, menuByPath)
        commit('SET_ACTIVE_MENU', menu)
        const activeMenuTree = deepQueryTree(state.allMenusTree, menu.id)
        commit('SET_ACTIVE_MENU_TREE', activeMenuTree)
        const activeMenuChildren =
            activeMenuTree.find((item) => item.id === menu.parentId || !menu.parentId)
                ?.children || []
        if (!activeMenuChildren || activeMenuChildren.length === 0) {
            activeMenuChildren.push(menu)
        }
        commit('SET_ACTIVE_MENU_CHILD', activeMenuChildren)
    },
    //0.获取公告 query路由参数
    async getNotice({dispatch, commit, state}, query) {
        let res = await bbwPurchaseApi.notice_detail(query);
        let project = res.data
        if (project) {
            if (query.notice_id) {
                project.currentNoticeId = query.notice_id
            } else {
                project.currentNoticeId = 0
            }
            // 1.更新当前项目信息
            let currentNotice = await dispatch('updateCurrentProject', project)
            console.log("currentNotice", currentNotice)
            // 2.更新当前公告 Promise
            return dispatch('updateCurrentNotice', currentNotice)
        }
        Promise.reject("项目数据异常");

    },

    // 1.更新当前项目信息
    async updateCurrentProject({dispatch, commit, state}, project) {
        commit('SET_CURRENTPROJECT', project)
        let currentNotice
        if (project.currentNoticeId != 0) {
            currentNotice = project.notices.filter(
                (item) => item.noticeId === project.currentNoticeId
            )[0]
        } else {
            currentNotice = project.notices[0]
        }
        return currentNotice;
    },
    // 2.更新当前公告
    updateCurrentNotice({dispatch, commit, state}, notice) {
        commit('SET_CURRENT_NOTICE', notice)
        let promiseArr = [
            dispatch('updateCurrentBids', notice),
            dispatch('updateNoticeHTML', notice),
        ]
        return Promise.all(promiseArr)
    },
    // 3.更新当前标段列表
    updateCurrentBids({dispatch, commit, state}, notice) {
        return new Promise((resolve, reject) => {
            bbwPurchaseApi
                .get_bid_by_notice(notice.noticeType, notice.noticeId)
                .then((res) => {
                    let data = res.data
                    for (let i = 0; i < data.length; i++) {
                        let dateItem = data[i]
                        let ejyDataCode = {
                            "JZXCS20240827000001-0001": "QT24081090800001/1",
                            "JZXCS20240827000002-0001": "QT404524080002/1",
                            "JZXCS20240827000004-0001": "QT404524080001/1",
                            "JZXCS20240827000005-0001": "BHQS-20240815",
                            "JZXCS20240827000006-0001": "ZFCG11000524080001/1",
                        }
                        if (ejyDataCode[dateItem.bidSectionCode]) {
                            dateItem.bidSectionCode = ejyDataCode[dateItem.bidSectionCode]
                            dateItem.otherLoginUrl = "https://buy.ejy365.com/user/loginpage?redirectUrl=aHR0cHM6Ly9neHdocHBtLmVqeTM2NS5jb20vIy9qdW1wP3NlY3Rpb25Obz1RVDI0MDgxMDkwODAwMDAxLzEmbm90aWNlSWQ9MTgyMjkzMTM2Mjk5NTMxNDY5MCZub3RpY2VOYW1lPeS4reS5vueri+a6kOW3peeoi+WSqOivouaciemZkOWFrOWPuOWFs+S6juaWsOiDvea6kOinguWFiei9pumHh+i0reernuS6ieaAp+eji+WVhuWFrOWRig==&systype=gxqlc"
                        } else {
                            dateItem.otherLoginUrl = false
                        }
                    }
                    commit('SET_CURRENT_BIDS', data)
                    resolve()
                })
                .catch((err) => {
                    console.error('获取标段列表失败')
                    commit('SET_CURRENT_BIDS', [])
                    reject("获取标段列表失败")
                })
        })
    },

    // 4.更新公告HTML数据
    updateNoticeHTML({commit, state}, notice) {
        if (notice.relType == 8) {
            //真实类型 8 =控制预算价，是富文本
            let selfNoticeObj = {
                isloading: false,
                html: notice.localUrl,
            }
            commit('SET_NOTICE_HTML', selfNoticeObj)
            return
        }

        if (notice.localUrl == '' || notice.htmlUrl == '') {
            let selfNoticeObj = {
                isloading: false,
                html: ''
            }
            commit('SET_NOTICE_HTML', selfNoticeObj)
            return
        }
        return new Promise((resolve, reject) => {
            //封装加载状态
            let noticeObj = {
                isloading: true,
                html: '',
            }
            if (notice.isDownLoad) {
                bbwPurchaseApi
                    .get_prod_HTML(notice.localUrl)
                    .then((res) => {
                        noticeObj.isloading = false
                        noticeObj.html = res
                        commit('SET_NOTICE_HTML', noticeObj)
                        resolve()
                    })
                    .catch((err) => {
                        bbwPurchaseApi.get_test_HTML(notice.localUrl).then(res => {
                            noticeObj.isloading = false
                            noticeObj.html = res
                            commit('SET_NOTICE_HTML', noticeObj)
                            resolve()
                        }).catch((err) => {
                            noticeObj.isloading = false
                            console.error('获取公告正文失败:', noticeObj)
                            commit('SET_NOTICE_HTML', noticeObj)
                            reject('获取公告正文失败')
                        })
                    })
            } else {
                bbwPurchaseApi
                    .get_requset(notice.htmlUrl)
                    .then((res) => {
                        noticeObj.isloading = false
                        noticeObj.html = res
                        commit('SET_NOTICE_HTML', noticeObj)
                        resolve()
                    })
                    .catch((err) => {
                        noticeObj.isloading = false
                        console.error('获取公告正文失败:', noticeObj)
                        commit('SET_NOTICE_HTML', noticeObj)
                        reject('获取公告正文失败')
                    })
            }
        })
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
